/**
 * @description Alpine directives
 */

import Alpine from "alpinejs";

/**
 * @param {HTMLElement} el
 * @param {string} expression
 * @param {string[]} modifiers
 * @returns {void}
 */
Alpine.directive(
  "money",
  (el, { expression, modifiers }, { evaluateLater, effect }) => {
    const raw = modifiers.includes("raw");
    const value = evaluateLater(expression);

    effect(() => {
      value((value) => {
        el.innerText = Shopify.helpers.asMoney(raw ? value : value / 100);
      });
    });
  }
);
